import client from '@/api/client';
import { gql } from '@apollo/client';
import grammarFragments from '@/gql-fragments/grammar';

const grammarSearch = (searchString: string) => client
  .query({
    query: gql`
    query($name: String) {
      getCourseElementTags(
        name: $name
      ) {
        ...GrammarElement
      }
    }
    ${grammarFragments.GrammarElement}
  `,
    variables: {
      name: searchString,
    },
  });

const topListGet = () => client
  .query({
    query: gql`
    query($page: Int, $itemsPerPage: Int) {
      getCourseElementTags(page: $page, itemsPerPage: $itemsPerPage) {
        ...GrammarElement
      }
    }
    ${grammarFragments.GrammarElement}
  `,
    variables: {
      page: 1,
      itemsPerPage: 10,
    },
  });

const fullListGet = () => client
  .query({
    query: gql`
    query($pagination: Boolean) {
      getCourseElementTags(pagination: $pagination) {
        ...GrammarElement
      }
    }
    ${grammarFragments.GrammarElement}
  `,
    variables: {
      pagination: false,
    },
  });

export {
  grammarSearch,
  topListGet,
  fullListGet,
};
